var site = site || {};
var generic = generic || {};

(function ($) {
  Drupal.behaviors.productKitV1 = {
    attach: function (context) {
      var $body = $('body', context);
      var $kitWrapper = $('.js-product-kit-formatter-v1', context);
      var $kitWrapperNewLayout = $('.js-single-product-layout', context);
      var isNewLayout = $kitWrapperNewLayout.length > 0;
      var productCount = 0;
      var $kitMenuItem = $('.js-product-kit-v1', $kitWrapper);
      var accordionCount = $kitMenuItem.length;
      var $prodSelectedCount = $('.js-selected-count', $kitWrapper);
      var $totalProductsCount = $('.js-total-count', $kitWrapper);
      var $productCarousel = $('.js-product-kit-container', $kitWrapper);
      var $skuSelect = $('select', $kitWrapper).not('.js-kit-skin-type', context);
      var $kitPriceContainer = $('.js-total-price', $kitWrapper);
      var $kitDiscountPriceContainer = $('.js-discount-price', $kitWrapper);
      var $kitDiscountPercentageContainer = $('.js-discount-percentage', $kitWrapper);
      var $kitDiscountOffCopy = $('.js-discount-off-copy', $kitWrapper);
      var kitPrice = 0;
      var $addToBag = $('.js-add-to-kit', $kitWrapper);
      var $addToBagSticky = $('.js-add-to-kit-sticky', $kitWrapper);
      var $shadeSelect = $('select.js-shades', $kitWrapper);
      var $kitSelect = $('select.js-kit-selectbox', $kitWrapper);
      var $reviewContainer = $('.js-star-rating', $kitWrapper);
      var $skintypeSelect = $('.js-kit-skin-type', context);
      var $sizeDropDown = $('.js-kit-size-dropdown', context);
      var $productUnitPrice = $('.js-unit-price', context);
      var showSelect = $('.js-kit-product-select-cta').data('show-select');
      var showSelected = $('.js-kit-product-select-cta').data('show-selected');
      var $tempOutStockMsg = site.translations.product.temp_out_of_stock_msg || '';
      var $kitStickyFooter = $('.js-kit-sticky-footer', $kitWrapper);
      var $errorMessage = $('.js-product-kit__error', $kitWrapper);
      var $errorShademessage = $('.js-shade-error-message', $kitWrapper);
      var $errorSizemessage = $('.js-size-error-message', $kitWrapper);
      var $kitStickyItems = $('.js-kit-sticky-items', $kitWrapper);
      var $kitSelectedItems = $('.js-kit-selection-container .js-kit-selected-items');
      var $kitContentTotalPrice = $('.js-product-total-price', $kitWrapper);
      var percentageSymbol = $kitStickyFooter.data('percentage-symbol');
      var currencySymbol = $kitWrapper.data('currency-symbol');
      var thousandsSeparator = $kitWrapper.data('thousands-separator');
      var decimalSeparator = $kitWrapper.data('decimal-separator');
      var showPricePerML = $kitWrapper.data('show-price-per-ml');
      var $document = $(document);
      var isMobile = $('body').hasClass('device-mobile');
      var offerDetails = {};
      var $productList = $('.js-product-list', $kitWrapper);
      var $kitSku;
      var $kitItemElement;
      var invStatus;
      var $itemElement;
      var $outOfStockSku;
      let reloadSKUChange = 1;
      var isDragging = false;
      var collectionInCart = 0;

      if (Drupal.settings.globals_variables.enable_custom_kitting) {
        $body.addClass('custom-kitting-enabled');
      }
      
      function formatPrice(price) {
        var formattedPrice = parseFloat(price).toFixed(2);
        var parts = formattedPrice.split('.');
        var integer = parts[0];
        var decimal = parts[1];
      
        // Defaults to US format
        thousandsSeparator = thousandsSeparator || ',';
        decimalSeparator = decimalSeparator || '.';
        // Insert thousand separator
        integer = integer.replace(/\B(?=(\d{3})(?!\d))/gu, thousandsSeparator);
      
        return integer + decimalSeparator + decimal;
      }

      function fixedEncodeURIComponent(str) {
        return encodeURIComponent(str).replace(/[!'()*]/gu, function (c) {
          return '%' + c.charCodeAt(0).toString(16);
        });
      }

      function setRouteUrl($item) {
        var isProdSized = $item.data('prod-sized');
        var isProdShaded = $item.data('prod-shaded');
        var productSize = $item.find('.js-product-size').attr('data-prod-size');
        var productShade = $item.find('.js-shades option:selected').attr('data-shade-name');
        var $productLink = $item.find('.js-product-link');
        var url = $productLink.attr('data-prod-url');
        var routePrefix;
        var routeString;
        var routeNoSpaces;

        if (isProdSized || isProdShaded) {
          routePrefix = isProdSized ? 'size=' : 'shade=';
          routeString = isProdSized ? productSize : productShade;

          if (routeString && url) {
            routeNoSpaces = fixedEncodeURIComponent(routeString.toString().replace(/\s+/gu, '_'));

            $productLink.attr('href', `${url}?${routePrefix}${routeNoSpaces}`);
          }
        }
      }

      $productList.each(function (index, item) {
        $itemElement = $(item);
        $kitSku = $itemElement.find('.js-sku-option');
        $outOfStockSku = $itemElement.find('.js-sku-oos');
        $sizeTextEl = '';
        $sizeText = '';

        if (showPricePerML === '' || showPricePerML === 0) {
          $productUnitPrice.html('');
        }
        if ($itemElement.find($kitSelect).length === 0) {
          $itemElement.addClass('js-product-single product-single');
          $itemElement.find('.js-kit-product-select-cta').removeClass('button--disabled');
        }

        if ($kitSku.length === 1) {
          const swatchColor = $kitSku[0].value;
          const defaultOptionName = $(`option[value="${swatchColor}"`, context).html();
          const $swatchCircle = $('<span/>', { class: 'swatch-circle' }).css(
            'background-color',
            swatchColor
          );
          const $filterSwatch = $('<div/>', { class: 'js-filtered-swatch filtered-swatch' })
            .append($swatchCircle);
          const $filterSwatchContainer = $('<div/>', { class: 'single-sku-shade' })
            .append($filterSwatch)
            .append(defaultOptionName);

          $itemElement.find('.js-kit-product-select-cta').removeClass('button--disabled');
          $itemElement.find('.js-kit-selectbox').remove();
          $itemElement.find('.js-product-kit__product-shades').prepend($filterSwatchContainer);
        }

        if ($itemElement.hasClass('js-product-single')) {
          invStatus = parseInt(
            $itemElement.find('.js-kit-no-size-dropdown').attr('data-inventory-status'),
            10
          );
          if (
            invStatus === 2 ||
            invStatus === 3 ||
            invStatus === 4 ||
            invStatus === 5 ||
            invStatus === 7 ||
            !invStatus
          ) {
            $itemElement.remove();
          }
        }

        $kitSku.each(function (index, kitItem) {
          $kitItemElement = $(kitItem);
          invStatus = parseInt($kitItemElement.attr('data-inventory-status'), 10);
          if (
            invStatus === 2 ||
            invStatus === 3 ||
            invStatus === 4 ||
            invStatus === 5 ||
            invStatus === 7 ||
            !invStatus
          ) {
            $kitItemElement.remove();
          }
        });

        if (
          $kitSku.length === $outOfStockSku.length &&
          !$itemElement.hasClass('js-product-single')
        ) {
          $itemElement.remove();
        }

        if ($kitSku.hasClass('js-kit-no-size-dropdown')) {
          $itemElement.find('.js-kit-skin-dropdown').remove();
        }

        // Remove extra size text to fix layout
        $sizeTextEl = $itemElement.find('.js-product-size');
        $sizeText = $sizeTextEl.text();
        if ($sizeText.includes('oz')) {
          $sizeTextEl.text($sizeText.split('oz.')[0] + 'oz.');
        }

        // Deep link updates
        setRouteUrl($itemElement);
      });

      var getRatingPercentage = function (average) {
        if (!average) {
          return null;
        }
        var scale = 5;
        var calc = average / scale;
        var perc = Math.round(calc * 100);

        return perc + '%';
      };
      var updateKitPrice = function () {
        var totalPrice = 0;
        var $selectedProducts = $('.selected', $kitWrapper)
          .closest('.slick-slide')
          .not('.slick-cloned');

        if ($selectedProducts.length) {
          $selectedProducts.each(function () {
            totalPrice += parseFloat($(this).find('.js-product-list').attr('data-price'));
          });
        }
        $kitPriceContainer.text(currencySymbol + formatPrice(totalPrice));
        calculateDiscountPrice(totalPrice);
      };

      $kitStickyItems.each(function (index, element) {
        var serialNo = index + 1;

        if (serialNo > accordionCount) {
          return false;
        }
        $(element).removeClass('hidden');
      });

      $kitSelectedItems.each(function (index, element) {
        var serialNo = index + 1;

        if (serialNo > accordionCount) {
          return false;
        }
        $(element).removeClass('hidden');
      });

      var showKitMaxErrorMessage = function () {
        if (!Drupal.settings?.single_custom_kit_on_cart_restriction) {
          return;
        }

        var $maxErrorMessage = $('.js-max-error-message', $kitWrapper);
        var $maxErrorCloseIcon = $('.js-max-error-close', $kitWrapper);

        if ($maxErrorMessage.length && !$maxErrorMessage.hasClass('active')) {
          $maxErrorMessage.addClass('active');

          $maxErrorCloseIcon.one('click', function () {
            $maxErrorMessage.removeClass('active');
          });
        }
      };

      var checkCollectionInCart = function (kitOffersInCart) {
        var offerCode = $addToBag.attr('data-offer-code');

        if (!offerCode) return;

        var offer = kitOffersInCart[offerCode];

        if (offer && offer.fields && offer.fields.in_cart) {
          collectionInCart = 1;
        }

        if(collectionInCart === 1) {
          showKitMaxErrorMessage();
        }
      };
      var defaultSkuSelection = function (selectBoxRefresh) {

        var skuMap = Object.create(null);

        $productCarousel.each(function (index, item) {
          var $productElement = $(item);
          var str = $productElement.attr('data-cms-default-sku');
          // Skip if empty or undefined
          if (!str) {
            return true;
          }
          $.each(str.split(','), function (_, pair) {
            pair = pair.trim();
            if (!pair) {
              return;
            }
            var parts = pair.split('~');
            if (parts.length < 2) {
              return;
            }
            var prodId = parts[0].trim();
            var skuRaw = parts[1].trim();
            var skuId = skuRaw.replace(/^SKU/i, '');
            if (prodId && skuId) {
              skuMap[prodId] = skuId;
            }
          });
        });

        $productList.each(function (index, item) {
          var $productItemElement = $(item);
          var productDefaultSku = $productItemElement.attr('data-sku-base-id');
          var productId = $productItemElement.attr('data-prod-id');

          if (productDefaultSku) {
            var $select = $productItemElement.find('select.js-shades');
            var $selectCTA = $productItemElement.find('.js-kit-product-select-cta');

            var cmsSku = skuMap[productId];
            var $option = $();

            if (cmsSku) {
                $option = $select.find('option[data-sku-base-id="' + cmsSku + '"]');

                if ($option.length) {
                    productDefaultSku = cmsSku;
                }
            }

            if (!$option.length) {
                $option = $select.find(
                    'option[data-sku-base-id="' + productDefaultSku + '"]'
                );
            }

            if ($option.length && $selectCTA.length) {
              var skuShade = $option.val();
              $select.val($option.val());
              $select.trigger('change');
              if (selectBoxRefresh) {
                if ($select.data('selectBox-control')) {
                  $select.selectBox('refresh');
                }
              } else {
                var $activeSelectBox = $productItemElement.find('a.js-shades.js-kit-selectbox');
                $activeSelectBox.children('.js-filtered-swatch').css({
                  'background-color': skuShade,
                  'border-color': skuShade
                });

                $selectCTA.removeClass('button--disabled');
              }
            }
          }
        });
      };

      var calculateDiscountPrice = function (totalPrice) {
        var offerCode = $addToBag.attr('data-offer-code');
        var offers = offerDetails.offers;
        var percentDiscountedPrice = 0;
        var flatDiscountedPrice = 0;
        var discountedPrice = 0;
        let discountPercentage;

        if (offers && typeof offers === 'object' && offers[offerCode]) {
          var offerValues = offers[offerCode];
          if (offerValues.fields.impossible !== 1) {
            $.each(offerValues.fields.benefits, function (index, benefits) {
              if (benefits.class === 'PercentDiscount') {
                percentDiscountedPrice = (totalPrice * benefits.value) / 100;
                discountPercentage = benefits.value;
              } else if (benefits.class === 'FlatDiscount') {
                flatDiscountedPrice = benefits.value;
              }
            });
          }
          var discountValue =
            percentDiscountedPrice > flatDiscountedPrice
              ? percentDiscountedPrice
              : flatDiscountedPrice;

          $kitWrapper.find('.js-total-price').removeClass('strike-out-price');

          if (discountValue > 0) {
            discountedPrice = totalPrice - discountValue;
            $kitDiscountPriceContainer.text(currencySymbol + formatPrice(discountedPrice));
            $kitPriceContainer.text(currencySymbol + formatPrice(totalPrice));
            if (discountPercentage) {
              $kitDiscountPercentageContainer.text(discountPercentage + percentageSymbol);
            }
            $kitDiscountOffCopy.removeClass('hidden');
            $kitContentTotalPrice.addClass('hidden');
            $kitWrapper.find('.js-total-price').addClass('strike-out-price');
          }
        }
      };
      var fetchOffers = function () {
        generic.jsonrpc.fetch({
          method: 'offers.query',
          params: [
            {
              view: 'custom_kitting_in_cart'
            }
          ],
          onSuccess: function (jsonRpcResponse) {
            var response = jsonRpcResponse.getValue();

            if (typeof response !== 'undefined') {
              offerDetails.offers = response.offers;
            }
            checkCollectionInCart(offerDetails.offers);
            return;
          },
          onFailure: function () {}
        });
      };

      fetchOffers();

      var fetchCartData = function () {
        generic.jsonrpc.fetch({
          method: 'trans.get',
          params: [],
          onSuccess: function (r) {
            var cartData = r.getValue();
            var offerCode = $addToBag.attr('data-offer-code');

            if (
              offerCode &&
              collectionInCart === 0 &&
              cartData &&
              cartData.appliedOffers &&
              cartData.appliedOffers[offerCode]
            ) {
              collectionInCart = 1;
            }

            if(collectionInCart === 1) {
              showKitMaxErrorMessage();
            }
          },
          onFailure: function () {}
        });
      };

      if (
        Drupal.settings?.single_custom_kit_on_cart_restriction &&
        $addToBag.attr('data-offer-code')
      ) {
        fetchCartData();
      }

      var skuChange = function () {
        $skuSelect.off('change').on('change', function (e) {
          e.stopPropagation();
          var $sku = $(this);
          var $selectedSku = $sku.find('option:selected');
          var skuId = $selectedSku.data('skuBaseId');
          var skuPrice = $selectedSku.data('skuPrice');
          var formattedPrice = $selectedSku.data('formattedPrice');
          var skuImage = $selectedSku.data('sku-image');
          var $activeImgContainer = $sku
            .closest('.js-product-kit-v1')
            .find('.slick-current')
            .find('.js-kit-img-container');
          var $skuSelectCTA = $sku.parents('.js-product-list').find('.js-kit-product-select-cta');
          var $activeSelectedList = $sku.closest('.js-product-list');
          var $productSelectBox = $productList.find('a.js-kit-selectbox');
          var $activeSelectBoxLabel = $activeSelectedList.find('.js-shades .js-sku-option');

          var $selectedProductCategory;
          var $activeSelectBox;

          $activeSelectedList.addClass('js-sku-selected');
          if ($kitSelect.hasClass('error')) {
            $kitSelect.removeClass('error');
            $kitSelect.next().remove();
          }
          if ($productSelectBox.hasClass('error')) {
            $productSelectBox.removeClass('error');
            $productSelectBox.next().remove();
          }
          if (
            isMobile && !isNewLayout &&
            ($skuSelectCTA.hasClass('button--disabled'))
          ) {
            $skuSelectCTA.removeClass('button--disabled button-selected');
            return false;
          } else {
            $skuSelectCTA.removeClass('button--disabled button-selected');
          }
          if (skuId !== '' && skuId !== undefined) {
            $skuSelectCTA.removeClass('button--disabled');
          } else {
            $skuSelectCTA.addClass('button--disabled');
            if(isNewLayout) {
              $skuSelectCTA.text(showSelect);
            }
            $activeSelectedList.find('.js-filtered-swatch').remove();
            $activeSelectedList.removeClass('js-sku-selected');
            $("<div class='js-filtered-swatch filtered-swatch'></div>").insertBefore(
              $activeSelectBoxLabel
            );
            return false;
          }
          if ($sku.hasClass('js-shades')) {
            skuShade = $selectedSku.data('hex-value');
            if (skuShade !== undefined && skuShade !== '') {
              $activeSelectedList.find('.js-filtered-swatch').remove();
              $("<div class='js-filtered-swatch filtered-swatch'></div>").insertBefore(
                $activeSelectBoxLabel
              );
              $activeSelectBox = $activeSelectedList.find('.selectBox-active');
              $activeSelectBox.children('.js-filtered-swatch').css({
                'background-color': skuShade,
                'border-color': skuShade
              });
            }
          }
          if ($activeSelectedList.hasClass('selected')) {
            $activeSelectedList.removeClass('selected');
            $skuSelectCTA.text(showSelect);
          }

          $sku
            .closest('.js-product-kit-info')
            .parent('.product-kit__products-list')
            .removeAttr('title');
          $sku.closest('.js-sku-option').removeAttr('title');

          $activeSelectedList.removeClass('selected');
          $skuSelectCTA.text(showSelect);
          $skuSelectCTA.removeClass('button-selected');
          $activeSelectedList
            .find('.js-kit-img-container')
            .children('.icon-selected')
            .addClass('hidden');

          if ($sku.hasClass('js-shades')) {
            var skuShade = $selectedSku.data('hex-value');
            var skuShadeDesc = $selectedSku.attr('data-shade-description');

            $('.selectBox-active')
              .children('.js-filtered-swatch')
              .css('background-color', skuShade);

            if (skuShadeDesc && isNewLayout) {
              $activeSelectedList.find('.js-shade-description').text(skuShadeDesc);
            }
          } else {
            var sizedSkuVal = $selectedSku.val();

            $sku.closest('.js-product-kit-info').find('.js-product-size').attr('data-prod-size', sizedSkuVal).html(sizedSkuVal);
          }
          if (isMobile && !isNewLayout) {
            var $activeSlick = $sku.closest('.slick-active');

            $activeSlick.find('.js-sku-price').text(formattedPrice);
            $activeSlick.find('.js-kit-image').attr('src', skuImage);
            $(document).trigger('kit.ImageContainer', $activeImgContainer);
            reloadSKUChange = 0;
          }
          $selectedProduct = $sku.parents('.js-product-list');
          $selectedProductCategory = $selectedProduct.closest('.js-product-kit-v1');
          $selectedProductCategory.addClass('editable');
          $selectedProduct.attr({
            'data-price': skuPrice,
            'data-formatted-price': formattedPrice,
            'data-sku-base-id': skuId
          });
          $sku.closest('.js-product-list').find('.js-kit-image').attr('src', skuImage);
          $sku.closest('.js-product-kit-info').find('.js-sku-price').html(formattedPrice);
          updateKitPrice();
          setRouteUrl($activeSelectedList);
          if(isNewLayout) {
            $selectedProduct.closest('.js-product-kit-v1').find('.js-kit-label').removeClass('selected');
          }
        });
      };

      if (isNewLayout) {
        $body.addClass('product-kit-new-layout');
        defaultSkuSelection(true);
      }

      var shadeSelect = function () {
        if ($shadeSelect !== undefined) {
          $shadeSelect.each(function () {
            $(this).selectBox({ mobile: true });
            var $select = $(this).selectBox('control');

            if (!$select) {
              return;
            }

            var $selectOption = $select.data('selectBox-options');
            var $selectMenuOptions = $('li a', $selectOption);

            $selectMenuOptions.prepend('<div class="js-filtered-swatch filtered-swatch"></div>');
            var shade = $selectMenuOptions.attr('rel');

            $select.prepend('<div class="js-filtered-swatch filtered-swatch"></div>');
            $select.children('.js-filtered-swatch').css('background-color', shade);
            $selectMenuOptions.each(function () {
              var $options = $(this);
              var selectShade = $options.attr('rel');

              $options.children('.js-filtered-swatch').css('background-color', selectShade);
            });
          });
        }
      };

      if (!isNewLayout) {
        shadeSelect();
      }

      $skintypeSelect.off('change').on('change', function () {
        var $skinSelect = $(this);
        var $sizeSelect = $skinSelect.parent().prev('.js-kit-size-dropdown').find('select');
        var $sizeSelectOption = $('option', $sizeSelect);

        if ($skinSelect.length && $skinSelect.find('option:selected').length) {
          $sizeSelectOption.prop('disabled', true);
          var selectedSkus = $skinSelect.find('option:selected').attr('data-skus').split(',');

          $(selectedSkus).each(function (index, val) {
            var $option = $sizeSelectOption.filter('[data-sku-base-id=' + val + ']');

            $option.prop('disabled', false);
            if (index === 0) {
              $option.prop('selected', true);
            }
          });
          $sizeSelect.trigger('change');
          $sizeSelect.selectBox('refresh');
        }
      });
      $skintypeSelect.trigger('change');
      if (isMobile && !isNewLayout) {
        $productCarousel.find('select').selectBox('destroy');
      }
      $productCarousel.slick({
        infinite: false,
        slidesToShow: 3.5,
        slidesToScroll: 3,
        variableWidth: true,
        swipe: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: !isNewLayout? 2.25: 1,
              slidesToScroll: !isNewLayout? 2: 1,
              variableWidth: false
            }
          }
        ]
      });

      // Detect when dragging starts
      $productCarousel.on('mousedown touchstart', function () {
        isDragging = false;
      });

      // Detect movement while dragging
      $productCarousel.on('mousemove touchmove', function () {
        isDragging = true;
      });

      // Reset dragging state when dragging ends
      $productCarousel.on('mouseup touchend', function () {
        setTimeout(function () {
          isDragging = false;
        }, 100);
      });

      if (!isNewLayout) {
        $productCarousel.find('select').selectBox();
      } else {
        shadeSelect();
      }

      skuChange();
      $prodSelectedCount.text(productCount);
      $totalProductsCount.text(accordionCount);
      $kitPriceContainer.text(currencySymbol + formatPrice(kitPrice));
      $reviewContainer.each(function () {
        var $currentProductRating = $(this);
        var averageReview = $currentProductRating.data('prod-rating');
        var reviewPercent = getRatingPercentage(averageReview);

        $currentProductRating.css('width', reviewPercent);
      });

      var dropDownChange = function ($productKit) {
        var $activeSlide = $productKit.find('.selected.slick-active');
        var selectedSkuText = isMobile
          ? $activeSlide.find('[selected="selected"]').text()
          : $activeSlide.find('span.js-kit-size-option').text();

        if (selectedSkuText) {
          $productKit.find('.js-kit-size-option-selected').text(selectedSkuText);
        }
        $('.selectBox-dropdown-menu .js-hide-oos-size').attr('title', $tempOutStockMsg);
      };

      $sizeDropDown.on('change', function () {
        var $this = $(this);

        if (isMobile) {
          $(document).trigger(
            'kitImageContainer',
            $this.closest('.js-product-kit-v1').find('.current-slide').find('.js-kit-img-container')
          );
        } else {
          $(document).trigger(
            'kit.ImageContainer',
            $this.closest('.js-product-list').find('.js-kit-img-container')
          );
        }
      });

      $(document).on('kit.errorMessage', function (event, currentElement) {
        var $productImage = $(currentElement);
        var $productSelectBox = $productList.find('a.js-kit-selectbox');
        var $productKit = $productImage.closest('.js-product-list');
        var $shadeSelectBox = $productKit.find('a.js-shades.js-kit-selectbox');
        var $sizeSelectBox = $productKit.find('a.js-size.js-kit-selectbox');
        var $activeProductSelectBox = $productKit.find('a.js-kit-selectbox');
        var $shadeSelectBoxMobile = $productKit.find('select.js-shades');
        var $sizeSelectBoxMobile = $productKit.find('select.js-size');
        var $activeSelectBoxMobile = $productKit.find('select.js-kit-selectbox');
        var $productKitInfo = $productKit.find('.js-product-kit-info');

        if (!$productKit.hasClass('js-sku-selected')) {
          $productSelectBox.removeClass('error');
          $kitSelect.removeClass('error');
          $activeProductSelectBox.addClass('error');
          $productList.find($errorMessage).remove();
          $errorShademessage.insertAfter($shadeSelectBox);
          $errorSizemessage.insertAfter($sizeSelectBox);
          if (isMobile) {
            $activeSelectBoxMobile.addClass('error');
            $errorShademessage.insertAfter($shadeSelectBoxMobile);
            $errorSizemessage.insertAfter($sizeSelectBoxMobile);
          }
        }
      });

      $('.js-kit-product-select-cta', context).on('click', function (e) {
        var $productImage = $(this);
        var $productKitContainer = $productImage.closest('.js-product-kit-container');
        var $slickNext = $productKitContainer.find('.slick-next');
        var $slickPrev = $productKitContainer.find('.slick-prev');
        var $productKit = $();
        var skuBaseId;
        var $thisProduct = $();
        var $product = $();
        var $productClone = $();
        var $selectedProducts = $();
        var currentIndex;
        var stickyImg;
        var $currentStickyItem;
        var $currentNonSelectStickyItem;
        var $currentSelectStickyItem;
        var $currentSelectStickyImg;
        var $currentSelectedItem;

        e.stopPropagation();

        if ($productImage.closest('.slick-active').length === 0) {
          if ($slickNext.hasClass('slick-disabled')) {
            $slickPrev.trigger('click');
          } else {
            $slickNext.trigger('click');
          }
        }

        if ($productImage.hasClass('button--disabled')) {
          $kitWrapper.trigger('kit.errorMessage', $productImage);
        } else {
          $productKit = $productImage.closest('.js-product-kit-v1');
          currentIndex = $kitMenuItem.index($productKit);
          $currentStickyItem = $kitStickyItems.eq(currentIndex);
          $currentSelectedItem = $kitSelectedItems.eq(currentIndex);
          $nextAccordion = $kitMenuItem.eq(currentIndex + 1);
          $currentSelectStickyItem = $currentStickyItem.find('.js-selected-sticky-items');
          $currentNonSelectStickyItem = $currentStickyItem.find('.js-non-selected-sticky-items');
          $currentSelectStickyImg = $('.js-sticky-img', $currentSelectStickyItem);
          $productKit.find('.selected').removeClass('selected');
          skuBaseId = $productImage.closest('.js-product-list').attr('data-sku-base-id');
          $thisProduct = $productKit.find('.js-product-list[data-sku-base-id="' + skuBaseId + '"]');
          $thisProduct.addClass('selected');
          $product = $productImage.closest('.selected');
          size = $product.find('.js-sizes option:selected').val();
          const selectedSkuBaseId = $product.attr('data-sku-base-id');
          $productClone = $product.clone().removeClass('selected slick-active');
          stickyImg = $product.find('.js-kit-image').attr('src');
          if (isNewLayout) {
            stickyImg = $product.find('.js-kit-image').attr('src') || $product.find('.js-kit-image').attr('data-src');
          }
          $productClone
            .find('.js-product-kit__product-size, .js-product-kit__product-shades')
            .remove();
          $productClone.find('.js-selected-sku-info').removeClass('hidden');
          $productKit.find('.js-product-thumb').empty().removeClass('hidden').append($productClone);
          $productKit.find('.js-product-thumb').addClass('js-added-product');
          $productKit.find('.js-product-title').removeClass('title-active');
          $productKit.find('.selected .js-product-title').addClass('title-active');
          $productKit.find('.js-kit-product-select-cta').removeClass('button-selected');
          $productKit.find('.selected .js-kit-product-select-cta').addClass('button-selected');
          $productKit.find('.js-kit-product-select-cta').text(showSelect);
          $productKit.find('.selected .js-kit-product-select-cta').text(showSelected);
          $productKit.find('.js-kit-label').addClass('selected');
          $productKit.find('.icon-selected').addClass('hidden');
          $thisProduct.find('.icon-selected').removeClass('hidden');
          $productKit.addClass('editable');
          $currentSelectStickyImg.attr('src', stickyImg);
          $currentSelectedItem.attr('data-sku-base-id', selectedSkuBaseId);
          $currentSelectedItem.find('.js-selected-img').attr('src', stickyImg);
          $currentSelectedItem
            .addClass('selected')
            .find('.js-selection-item')
            .removeClass('hidden');
          $currentSelectStickyItem.removeClass('hidden').addClass('selected');
          $currentNonSelectStickyItem.addClass('selected');
          $selectedProducts = $('.js-kit-selected-items[data-sku-base-id]', $kitWrapper);
          productCount = $selectedProducts.length;
          $prodSelectedCount.text(productCount);
          $totalProductsCount.text(accordionCount);
          updateKitPrice();
          if (productCount === accordionCount) {
            if (!(Drupal.settings?.single_custom_kit_on_cart_restriction && collectionInCart)) {
              $addToBag.removeClass('button--disabled').addClass('active');
            }
            if (isMobile) {
              $kitStickyFooter.addClass('move-up');
              $addToBagSticky.addClass('fade-in');
            }
          }
          skuChange();
        }
      });

      $(document).on('kit.ImageContainer', function (event, $ele) {
        var $productImage = $($ele);
        var $productKit = $productImage.closest('.js-product-kit-v1');

        $productKit.find('.selected').removeClass('selected');
        var skuBaseId = $productImage.closest('.js-product-list').attr('data-sku-base-id');
        var $thisProduct = $productKit.find('.js-product-list[data-sku-base-id="' + skuBaseId + '"]');

        $thisProduct.addClass('selected');
        var $product = $productImage.closest('.selected');
        var $productClone = $product.clone().removeClass('selected slick-active');

        $productClone.find('.js-kit-size-option').removeClass('hidden');
        $productKit.find('.js-product-thumb').empty().removeClass('hidden').append($productClone);
        $productKit.find('.js-product-thumb').addClass('js-added-product');
        if (!isNewLayout) {
          $productKit.find('.js-label-info').addClass('hidden');
        }
        var $prodThumb = $productKit.find('.js-product-thumb').find('.js-product-kit-info');
        var $selectedProducts = $('.selected', $kitWrapper)
          .closest('.slick-slide')
          .not('.slick-cloned');

        $prodThumb.removeClass('mobile-hidden');
        dropDownChange($productKit);
        productCount = $selectedProducts.length;
        $prodSelectedCount.text(productCount);
        $totalProductsCount.text(accordionCount);
        updateKitPrice();
        if (productCount === accordionCount) {
          $addToBag.removeClass('button--disabled').addClass('active');
        }
        $productKit.find('.icon-selected').addClass('hidden');
        $thisProduct.find('.icon-selected').removeClass('hidden');
        $productKit.addClass('editable');
        $productKit.find('.js-list-no').removeClass('product-kit__list-no--active');
        event.stopPropagation();
      });

      $('.js-kit-img-container', context).on('click', function (e) {
        $kitWrapper.trigger('kit.errorMessage', $(this));

        if (isDragging) {
          // Prevent click event during drag
          e.preventDefault();
        } else {
          $(this).closest('.js-product-list').find('.js-kit-product-select-cta').trigger('click');
        }
      });

      $productCarousel.on('afterChange', function (e, slick, currentSlide) {
        $productList.removeClass('current-slide');
        var $product = $(slick.$slides[currentSlide]);
        var $productKit = $product.closest('.js-product-kit-v1');
        reloadSKUChange = 1;
        $product.addClass('current-slide');
      });
      var $firstAccordion = $kitMenuItem.first();

      $firstAccordion.children('.js-kit-label').trigger('click', true);

      if (isNewLayout) {
        defaultSkuSelection(false);
      }

      var enableAddToBag = function () {
        if (Drupal.settings.globals_variables.enable_added_to_bag) {
          $('.js-add-to-bag').removeClass('hidden');
          $('.js-added-to-bag').addClass('hidden');
          if (!(Drupal.settings?.single_custom_kit_on_cart_restriction && collectionInCart)) {
            $addToBag.removeClass('button--disabled button--added').addClass('active');
          }
        }
      };

      var enableAddedToBag = function () {
        if (Drupal.settings.globals_variables.enable_added_to_bag) {
          $('.js-add-to-bag').addClass('hidden');
          $('.js-added-to-bag').removeClass('hidden');
          $addToBag.addClass('button--disabled button--added').removeClass('active');
        }
      };

      var showKitCartOverlay = function (collectionId) {
        generic.jsonrpc.fetch({
          method: 'trans.get',
          params: [],
          onSuccess: function (r) {
            var resultGetValue = r.getValue();
            var resultGetData = {};

            resultGetData.coll_info = {};
            resultGetData.trans_data = {};
            resultGetData.trans_data.order = {};
            resultGetData.trans_data.order.kits = {};
            resultGetData.coll_info.COLLECTION_ID = collectionId;
            resultGetData.trans_data.order.kits = Object.assign({}, resultGetValue?.order.kits);
            resultGetData.trans_data.items_count = resultGetValue?.items_count;
            $document.trigger('addKitToCart.success', [resultGetData]);
            enableAddToBag();
          },
          onFailure: function (err) {
            var resultMessages = err.getMessages();

            enableAddToBag();
            $document.trigger('addToCart.failure', [resultMessages]);
          }
        });
      };

      $addToBag.on('click', function () {
        var args = args || {};
        const $selectedItem = $('.js-kit-selected-items[data-sku-base-id]', $kitWrapper);
        var $this = $(this);
        var defaultSku = $this.attr('data-default-sku');
        var giftwrapSku = $this.attr('data-giftwrap-sku');
        var offerCode = $this.attr('data-offer-code');
        var collectionId;
        let $selectedItemElem;
        let selectedSkuIds = [];
        const quickbackAddToBag = Drupal.settings.globals_variables.quickback_add_to_bag || false;

        enableAddedToBag();
        if ($selectedItem.length !== accordionCount) {
          return;
        }
        if (defaultSku) {
          selectedSkuIds.push(defaultSku);
        }
        $selectedItem.each(function () {
          $selectedItemElem = $(this);
          selectedSkuIds.push($selectedItemElem.attr('data-sku-base-id'));
        });
        if (giftwrapSku) {
          selectedSkuIds.push(giftwrapSku);
        }

        var kitName = $this.attr('data-kit-name');

        if (!!kitName) {
          kitName = kitName + ' ';
        } else {
          kitName = Drupal.settings.default_kit_name;
        }

        /* Prod - PreProd - Sometimes, the CSRF token is not generated on the first time page load.
           We need to regenerate it and then add the custom kit. */
        if (!$.cookie('csrftoken')) {
          generic.jsonrpc.csrfInProgress = false;
          generic.jsonrpc.cachedCSRFPromise = null;
        }

        args.COLLECTION_TYPE = 'UKIT';
        args.COLLECTION_SUBTYPE = 'CUSTOM_KIT';
        args.SKU_BASE_ID = selectedSkuIds;
        args._SUBMIT = 'alter_collection';
        args.QTY = 1;
        args.COLLECTION_NAME = kitName + Math.floor(Math.random() * 10000);
        args.action = 'add,edit,create_kit';
        args.HAS_MULTIPLE_SKUS = 1;
        args.offer_code = offerCode;
        generic.jsonrpc.fetch({
          method: 'Cart',
          params: [args],
          onSuccess: function (r) {
            var responseData = r.getData();
            collectionInCart = 1;
            if ($('.cart-confirm').length === 0) {
              $document.trigger('addToCart.success', r.getCartResults());
              enableAddToBag();
            } else if (quickbackAddToBag) {
              enableAddToBag();
            }

            if (responseData.coll_info) {
              collectionId = responseData.coll_info.COLLECTION_ID;

              if ($kitStickyFooter.find('.js-total-price').hasClass('strike-out-price') || (isNewLayout && offerCode)) {
                generic.jsonrpc.fetch({
                  method: 'offers.apply',
                  params: [
                    {
                      offer_code: offerCode
                    }
                  ],
                  onSuccess: function () {
                    showKitCartOverlay(collectionId);
                  },
                  onFailure: function () {
                    showKitCartOverlay(collectionId);
                  }
                });
              } else {
                showKitCartOverlay(collectionId);
              }
            } else {
              enableAddToBag();
              return;
            }
          },
          onFailure: function (err) {
            var resultData = err.getData();
            var resultMessages = err.getMessages();
            var wasKitSuccessfulAdded = Array.isArray(resultMessages) &&
              resultMessages.length > 0 &&
              resultMessages[0]?.key === 'success.add_sku.collection.ukit';

            collectionId = resultData?.coll_info?.COLLECTION_ID;

            if (collectionId && wasKitSuccessfulAdded) {
              showKitCartOverlay(collectionId);
            } else {
              enableAddToBag();
              $document.trigger('addToCart.failure', [resultMessages]);
            }
          }
        });
      });
    }
  };
})(jQuery);
